
export const SPEECH_TYPES = {
  speakersList: "Speaker's List",
  moderated: "Moderated",
  unmoderated: "Unmoderated",
  formal: "Formal",
  comment: "Comment",
  crisis: "Crisis"
};

export const SPEECH_TYPES_ORDERED = [
  "Speaker's List",
  "Moderated",
  "Unmoderated",
  "Formal",
  "Comment",
  "Crisis"
]

export const TAGS = [
  "Great Points",
  "Convincing Speaker",
  "Good Body Language",
  "Shows Leadership",
  "Encourages Others",
  "Uses Parli Pro Well",
  "Well Researched",
  "Highly Professional",
  "Represents Delegation",
  "Persuasive Caucuser",
  "Teaches Others",
  "Good Partnership",
  "Leverages Resources",
  "On Topic",
  "Well Written Resolution",
  "Makes Connections"
];

export const SORTS = {
  a_z: "A-Z",
  z_a: "Z-A",
  spoken_most: "Spoken most",
  spoken_least: "Spoken least",
  latest_first: "Latest first",
  earliest_first: "Earliest first",
  highest_score: "Highest score",
  lowest_score: "Lowest score"
};